import { createSlice, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {ProcessResult} from "../../../domain/process-result/interfaces";
import {FormComponentDM, FormConfiguration, FormSettings} from "../interfaces";

interface StateInterface {
    isDebug: boolean,
    firstLoad: boolean,
    formComponentList:FormComponentDM [],
    formSettings:FormSettings,
    formConfiguration: FormConfiguration,
    pResult: ProcessResult,
    resultMessageShow:boolean
}

// initial state
const initialState: StateInterface = {
    isDebug:false,
    firstLoad:true,
    formComponentList: [] as FormComponentDM [],
    formConfiguration:{editableAreas:[]} as FormConfiguration,
    formSettings:{} as FormSettings,
    pResult:{} as ProcessResult,
    resultMessageShow:false
};

// the main slice
const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {
        main(state, action) {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

const store = configureStore({
    reducer: rootSlice.reducer,
});

export const rootActions = rootSlice.actions;
export default store;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
